<template>
  <div>
    <div>
      <b-card>
        <b-card-title class="text-danger h2">Add Post</b-card-title>
        <b-form @submit.prevent class="pt-3">
          <validation-observer ref="PostValidation">
            <b-row>
              <b-col md="12" class="mb-1">
                <b-form-group label="Post Title">
                  <validation-Provider
                    name="Post Title"
                    v-slot="{ errors }"
                  >
                    <b-form-input
                      v-model="title"
                      placeholder="Enter Post Title"
                    ></b-form-input>
                    <span class="text-danger">{{ errors[0] }}</span>
                  </validation-Provider>
                </b-form-group>
              </b-col>

              <b-col md="12" class="mb-1">
                <b-form-group label="Post Media (Image or Video)">
                  <validation-Provider
                    name="Post Media"
                    rules="required"
                    v-slot="{ errors }"
                  >
                    <b-form-file
                      v-model="file"
                      @change="handleFileChange"
                      placeholder="Choose a file or drop it here..."
                      drop-placeholder="Drop file here..."
                    ></b-form-file>
                    <span class="text-danger">{{ errors[0] }}</span>
                  </validation-Provider>
                </b-form-group>
              </b-col>

              <b-col md="12" class="mb-1 text-center">
                <b-button
                  variant="primary"
                  @click="addPost()"
                  block
                  type="submit"
                >
                  Submit Post
                </b-button>
              </b-col>
            </b-row>
          </validation-observer>
        </b-form>
      </b-card>
    </div>
  </div>
</template>

<script>
import {
  BCard,
  BCardTitle,
  BForm,
  BFormGroup,
  BFormInput,
  BButton,
  BCol,
  BRow,
  BFormFile,
} from "bootstrap-vue";
import { ValidationObserver } from "vee-validate";
import { ValidationProvider } from "vee-validate/dist/vee-validate.full.esm";
// Import your Post API file here
import postApi from "@/Api/Modules/posts"; 

export default {
  name: "AddPost",
  components: {
    BCard,
    BCardTitle,
    BForm,
    BFormInput,
    BFormFile,
    BFormGroup,
    BButton,
    BCol,
    BRow,
    ValidationObserver,
    ValidationProvider,
  },
  data() {
    return {
      title: "",
      file: null,
    };
  },

  methods: {
    handleFileChange(event) {
      // Simple file selection. We do NOT resize here to support Videos.
      this.file = event.target.files[0];
    },

    async addPost() {
      if (await this.$refs.PostValidation.validate()) {
        await this.$vs.loading({
          scale: 0.8,
        });

        let form = new FormData();
        form.append("title", this.title);
        form.append("file", this.file);

        await postApi
          .AddPost(form)
          .then(() => {
            this.$vs.loading.close();
            // The API file handles the redirect/reload
          })
          .catch(() => {
            this.$vs.loading.close();
          });
      }
    },
  },
};
</script>